import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `ms` — updates only after the input stops changing
 * for that long. Used to gate expensive work (search requests, live query runs)
 * behind a typing pause. Shared by the sidebar Search and the SQL editor preview.
 */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
